module.exports = __webpack_public_path__ + "media/sms.b4b2a643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/bouncy/assets/sms.svg
// module id = ./src/templates/bouncy/assets/sms.svg
// module chunks = 0